/* unplugin-vue-components disabled */import script from "./TodoItem.vue?vue&type=script&setup=true&name=TodoItem&lang=js"
export * from "./TodoItem.vue?vue&type=script&setup=true&name=TodoItem&lang=js"

import "./TodoItem.vue?vue&type=style&index=0&id=10ab10c6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ab10c6"]])

export default __exports__